// initial state
const state = {
  license: null,
  isLoggedIn: false
}

// getters
const getters = {
  loggedIn({state}) {
    return state.isLoggedIn;
  }
}

// actions
const actions = {
  set({commit}, license) {
    commit('setLicense', license);
  },
  logIn({commit}) {
    commit('setIsLoggedIn', true);
  },
  logOut({commit}) {
    commit('setLicense', null);
    commit('setIsLoggedIn', false);
  }
}

// mutations
const mutations = {
  setLicense(state, license) {
    state.license = license;
  },
  setIsLoggedIn(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}